<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="row">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="All Classes"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="0">All</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Section Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
              size="large"
                v-model="selectedSection"
                placeholder="All Sections"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <a-select-option :value="0">All</a-select-option>
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                  {{section.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Teacher Select -->
<!-- Teacher Select -->
<div class="col-md-4 col-12 mb-2">
  <a-spin :spinning="teacherSpinning">
    <a-select
      size="large"
      v-model="selectedTeacher"
      placeholder="All Teachers"
      style="width: 100%"
      allowClear
      show-search
      optionFilterProp="children"

      @change="handleTeacherChange"
    >
      <a-select-option :value="0">All</a-select-option>

      <a-select-option
        v-for="teacher in teachers"
        :key="teacher.id"
        :value="teacher.id"
      >
        {{ teacher.name }}
      </a-select-option>
    </a-select>
  </a-spin>
</div>

          <div class="col-md-2 col-12 mb-2 text-right">
            <div class="d-inline-flex flex-row">
              <div class="mr-2">
                <bulk-upload-timetable v-if="rolesetting.insertable" @uploaded="handleAfterUpload"/>
              </div>
            </div>
          </div>
        </div>

        <a-spin :spinning="loading">
          <div class="card">
            <div class="card-body">
              <div v-if="timetableData && Object.keys(timetableData).length">
                <div class="row mb-3">
                  <div class="col-md-6">
                    <div>
                      <button
                        v-if="canDownload"
                        type="button"
                        class="btn btn-light btn-sm btn-with-addon"
                        @click="download"
                      >
                        <span class="btn-addon">
                          <i class="btn-addon-icon fe fe-download" />
                        </span>
                        Download PDF
                      </button>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-right">
                      <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon mr-2"
                        @click="addNewColumn"
                      >
                        <span class="btn-addon">
                          <i class="btn-addon-icon fe fe-plus" />
                        </span>
                        Column
                      </a>
                      <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
                        @click="removeColumn"
                      >
                        <span class="btn-addon">
                          <i class="btn-addon-icon fe fe-minus" />
                        </span>
                        Last Column
                      </a>
                    </div>
                  </div>
                </div>
                <vue-custom-scrollbar
                  class="scroll-area"
                  :suppressScrollY='true'
                >
                <div id="timetableView">
                  <neo-print-wrapper title="Time Table">
                    <!-- Class, section, Session -->
                    <div class="d-none d-print-block">
                      <p>Class: <span class="font-weight-bold">{{getSelectedName(schoolClasses, selectedClass)}}</span>, Section: <span class="font-weight-bold">{{getSelectedName(sections, selectedSection)}}</span>, Session: <span class="font-weight-bold">{{getSelectedName(schoolSessions, selectedSession)}}</span></p>
                    </div>
                    <!-- Timetable -->
                    <table class="table table-sm table-bordered">
                      <thead>
                        <tr class="text-center">
                          <th scope="col">p</th>
                          <th scope="col" v-for="position in noOfColumns" :key="position">
                            <small class="font-weight-bold text-muted neo-opacity-50">{{ position }}</small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="day in workingWeekDays" :key="day.value">
                          <th scope="row" class="bg-dark text-center" style="vertical-align: middle;">
                            <p class="m-0 text-light">{{day.name}}</p>
                          </th>
                          <td v-for="position in noOfColumns" :key="position" class="neo_timetable_cell bg-light p-1">
                            <div v-if="getTableCellData(position, day.value)">
                              <timetable-cell :cellData="getTableCellData(position, day.value)" :rolesetting="rolesetting" :isTeacherMode="!!selectedTeacher" @updateTable="handleUpdateTable"/>
                            </div>
                            <div v-else class="text-center py-2">
                              <a
                                href="javascript:;"
                                class="p-2 bg-light text-muted neo-opacity-50"
                                @click="openAddTimetableForm(position, day.value)"
                                v-if="rolesetting.insertable"
                              >
                                <i class="fe fe-plus"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </neo-print-wrapper>
                </div>
                </vue-custom-scrollbar>
              </div>

              <!-- If no timetable data -->
              <div v-else class="text-center my-5">
                <a-tag color="purple">Please select a Class and Section to view Timetable data.</a-tag>
              </div>
            </div>
          </div>
        </a-spin>

      </div>
    </div>
    <add-timetable-entry @created="handleUpdateTable"/>
    <add-teacher-timetable-entry @created="handleUpdateTable"/>
    <edit-timetable-entry @updated="handleUpdateTable"/>
    <edit-teacher-timetable-entry @updated="handleUpdateTable"/>
  </div>
</template>

<script>
import { find } from 'lodash'
import { workingWeekDays } from '@/services/globaldata'

import vueCustomScrollbar from 'vue-custom-scrollbar'
import NeoPrintWrapper from '@/components/layout/Print/Default'

import TimetableCell from '@/components/timetable/Display/partials/tablecell'
import AddTimetableEntry from '@/components/timetable/Form/Add/index'
import EditTimetableEntry from '@/components/timetable/Form/Edit/index'
import EditTeacherTimetableEntry from '@/components/timetable/Form/TeacherEditForm/index'
import BulkUploadTimetable from '@/components/timetable/Bulk/index'
import AddTeacherTimetableEntry from '@/components/timetable/Form/TeacherAddForm/index'
// import DisplayTimetable from '@/components/timetable/Display/index'

export default {
  components: {
    BulkUploadTimetable,
    TimetableCell,
    AddTimetableEntry,
    AddTeacherTimetableEntry,
    EditTimetableEntry,
    EditTeacherTimetableEntry,
    vueCustomScrollbar,
    NeoPrintWrapper,
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
        this.getTeachers()
      })
      .catch(error => {
        console.log(error)
      })
  },
  props: {
    rolesetting: { type: Object },
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
    isTeacherMode() {
      return !!this.selectedTeacher
    },
    isClassSectionMode() {
      return !!this.selectedClass || !!this.selectedSection
    },
    canDownload() {
      return this.selectedTeacher || (this.selectedClass && this.selectedSection)
    },

  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: false,
      defaultNoOfColumns: 10,
      noOfColumns: 10,
      highestPosition: 10,
      data: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      workingWeekDays,
      teachers: [],
      teacherSpinning: false,
      selectedTeacher: 0,
      selectedClass: 0,
      selectedSection: 0,
      selectedSession: undefined,
      sectionSpinning: false,
      classSpinning: false,
      timetableData: null,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getClassSectionTimetable() {
      this.loading = true
      this.$http.get('/api/timetable', {
        params: {
          class_id: this.selectedClass || null,
          section_id: this.selectedSection || null,
          session_id: this.selectedSession || null,
        },
      })
        .then(({ data }) => {
          this.timetableData = data.data.timetable
          this.highestPosition = data.data.highest_position

          if (data.data.highest_position > this.defaultNoOfColumns) {
            console.log(data.data.highest_position)
            this.noOfColumns = data.data.highest_position + 1
          }

          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    handleUpdateTable: function() {
      if (this.selectedTeacher) {
        this.getTeacherTimetable()
      } else {
        this.getClassSectionTimetable()
      }
    },
    handleAfterUpload: function() {
      if (this.selectedTeacher) {
        this.getTeacherTimetable()
      } else {
        this.getClassSectionTimetable()
      }
    },

    getTeachers() {
      this.teacherSpinning = true

      let allTeachers = []
      let currentPage = 1
      let totalPages = 1

      this.$http.get('/api/teacher/', {
        params: {
          page: currentPage,
          session_id: this.selectedSession,
        },
      })
        .then(firstPageResponse => {
          const firstPageData = firstPageResponse.data

          allTeachers = [
            ...allTeachers,
            ...firstPageData.data,
          ]

          if (firstPageData.meta && firstPageData.meta.last_page) {
            totalPages = firstPageData.meta.last_page
          }

          if (totalPages > 1) {
            const pagePromises = []

            for (let page = 2; page <= totalPages; page++) {
              pagePromises.push(
                this.$http.get('/api/teacher/', {
                  params: {
                    page,
                    session_id: this.selectedSession,
                  },
                }),
              )
            }

            return Promise.all(pagePromises).then(responses => {
              responses.forEach(response => {
                allTeachers = [
                  ...allTeachers,
                  ...response.data.data,
                ]
              })
              return allTeachers
            })
          }

          return allTeachers
        })
        .then(allTeachersResult => {
          this.teachers = allTeachersResult.map(t => ({
            id: t.id,
            name: `${t.suffix ? t.suffix + ' ' : ''}${t.first_name} ${t.last_name}`.trim(),
          }))

          console.log(
            `Loaded ${this.teachers.length} teachers from ${totalPages} pages`,
          )
        })
        .catch(error => {
          console.error('Failed to fetch teachers', error)

          this.$notification.error({
            message: 'Failed to load teachers',
            description: 'Please try again later.',
          })
        })
        .finally(() => {
          this.teacherSpinning = false
        })
    },

    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.selectedClass = value

      if (value) {
        this.selectedTeacher = 0 // 🔥 reset teacher
      }

      this.selectedSection = 0
      this.timetableData = null
      this.noOfColumns = this.defaultNoOfColumns

      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      } else {
        this.sections = []
        this.getClassSectionTimetable()
      }
    },

    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange(value) {
      this.selectedSection = value
      this.timetableData = null
      this.noOfColumns = this.defaultNoOfColumns
      this.getClassSectionTimetable()
    },

    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined
      this.timetableData = null
      this.noOfColumns = this.defaultNoOfColumns

      this.getClasses()
      this.getTeachers()
      this.selectedTeacher = undefined
    },
    handleTeacherChange(value) {
      this.selectedTeacher = value

      if (value !== 0) {
        this.selectedClass = 0
        this.selectedSection = 0
        this.sections = []
      }
      this.timetableData = null
      this.noOfColumns = this.defaultNoOfColumns

      this.getTeacherTimetable()
    },

    getTeacherTimetable() {
      if (!this.selectedTeacher) return

      this.loading = true

      this.$http.get('/api/timetable/teacher', {
        params: {
          teacher_id: this.selectedTeacher,
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.timetableData = { ...data.data.timetable }
          this.highestPosition = data.data.highest_position

          if (data.data.highest_position > this.defaultNoOfColumns) {
            this.noOfColumns = data.data.highest_position + 1
          }

          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },

    addNewColumn() {
      if (this.noOfColumns < 25) {
        this.noOfColumns++
      }
    },
    removeColumn() {
      this.noOfColumns = this.noOfColumns - 1
    },
    openAddTimetableForm(position, day) {
      // Teacher Mode
      if (this.selectedTeacher) {
        this.$eventBus.$emit('openTeacherAddEntryModal', {
          teacherId: this.selectedTeacher,
          sessionId: this.selectedSession,
          position,
          day,
        })

        return
      }

      // Class Mode
      this.$eventBus.$emit('openTimetableAddEntryModal', {
        classId: this.selectedClass,
        sectionId: this.selectedSection,
        sessionId: this.selectedSession,
        position,
        day,
      })
    },

    getTableCellData(position, day) {
      if (!this.timetableData) return null
      if (!this.timetableData[day]) return null

      return find(this.timetableData[day], {
        position: position,
        day: day,
      })
    },

    getSelectedName(data, dataId) {
      if (!dataId) return 'All'
      const item = find(data, ['id', dataId])
      return item ? item.name : 'All'
    },
    download() {
      const header = {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        responseType: 'blob',
      }

      let apiUrl = ''
      let payload = {}
      let fileName = 'Timetable.pdf'

      // 🔥 Teacher Mode
      if (this.selectedTeacher) {
        apiUrl = '/api/timetable/pdf/teacher'

        payload = {
          teacher_id: this.selectedTeacher,
          session_id: this.selectedSession,
        }

        var teacherObj = this.teachers.find(t => t.id === this.selectedTeacher)
        var teacherName = teacherObj ? teacherObj.name : 'Teacher'

        fileName = 'Timetable_' + teacherName + '.pdf'
      } else {
        apiUrl = '/api/timetable/pdf'
        payload = {
          session_id: this.selectedSession,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
        }

        var classObj = this.schoolClasses.find(c => c.id === this.selectedClass)
        var className = classObj ? classObj.name : 'Class'

        var sectionObj = this.sections.find(s => s.id === this.selectedSection)
        var sectionName = sectionObj ? sectionObj.name : 'Section'

        fileName = 'Timetable_' + className + '_' + sectionName + '.pdf'
      }

      this.$http.post(apiUrl, payload, header)
        .then(({ data }) => {
          var FILE = window.URL.createObjectURL(new Blob([data]))
          var docURL = document.createElement('a')

          docURL.href = FILE
          docURL.setAttribute('download', fileName)

          document.body.appendChild(docURL)
          docURL.click()
        })
        .catch(error => {
          console.log(error)
        })
    },

    // download() {
    //   const header = { headers: { 'Content-Type': 'application/jsons', Accept: 'application/json' },
    //     responseType: 'blob' }
    //   const className = (this.schoolClasses.filter(item => item.id === this.selectedClass))[0].name
    //   const sectionName = (this.sections.filter(item => item.id === this.selectedSection))[0].name
    //   const fileName = `Timetable_${className}  ${sectionName}.pdf`
    //   console.log('fileName', fileName)
    //   this.$http.post(`/api/timetable/pdf`, {
    //     session_id: this.selectedSession,
    //     class_id: this.selectedClass,
    //     section_id: this.selectedSection,
    //   }, header)
    //     .then(({ data }) => {
    //       var FILE = window.URL.createObjectURL(new Blob([data])) // new Blob([res.data], { type: 'application/json' }) // window.URL.createObjectURL(new Blob([res.data]))
    //       var docURL = document.createElement('a')
    //       docURL.href = FILE
    //       docURL.setAttribute('download', fileName)
    //       document.body.appendChild(docURL)
    //       docURL.click()
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
  },
}
</script>
<style lang="scss" scoped>
.neo_timetable_cell {
  width: 150px;
  vertical-align: middle!important;
}
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
}
</style>
